<template>
  <div class="border-beige-40 mt-4 rounded border pb-2">
    <template v-if="!fieldData || argPairs.length < fieldData.length">
      <div class="flex justify-end pr-16">
        <RfButtonNew type="link" size="link" @click="addArgRow">
          <RfAddIcon class="h-5 w-5" />
          Add argument
        </RfButtonNew>
      </div>
    </template>
    <div class="flex flex-col gap-2">
      <RfAdvancedArgumentsRow
        v-for="(_, index) in argPairs"
        :key="index"
        ref="advancedArgumentsRows"
        v-model:fieldDataPair0="argPairs[index][0]"
        v-model:fieldDataPair1="argPairs[index][1]"
        :showFieldData="!!(fieldData && fieldData.length)"
        :fieldData="getFieldData(index)"
        :fieldDataValues="getFieldDataValues(argPairs[index][0])"
        @delete="deleteArgRow(index)"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, watchEffect } from "vue";
import RfAdvancedArgumentsRow from "./RfAdvancedArgumentsRow.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfAddIcon from "@/components/icons/RfAddIcon.vue";

const props = defineProps({ loadedArgs: { type: Object, default: () => ({}) } });
const emit = defineEmits(["update:argPairs"]);
const argPairs = ref([]);
const fieldData = ref([]);
const advancedArgumentsRows = ref([]);

const initArgs = (args, data) => (
  (argPairs.value = Object.entries(args || props.loadedArgs || {})),
  (fieldData.value = data)
);
const addArgRow = () => argPairs.value.push(["", ""]);
const deleteArgRow = index => argPairs.value.splice(index, 1);
const getArgs = () =>
  Object.fromEntries(
    argPairs.value.filter(([key, value]) => key && key.length && value && value.length),
  );

const getFieldDataValues = key => fieldData.value?.find(el => el.var === key) || {};
const getFieldData = index =>
  fieldData.value?.filter(
    el => !argPairs.value?.find(([key, _], i) => key === el.var && index !== i),
  );
const hasError = computed(() => !!advancedArgumentsRows.value.find(el => !!el.error));
onMounted(initArgs);

watchEffect(() => emit("update:argPairs", getArgs()));
defineExpose({ init: initArgs, get: getArgs, hasError });
</script>
